import request from '../../../helpers/request';

const addClientPassportInfo = async (values) => {
  const response = await request.post(
    `/HousingStock/client/documents/passport`,
    values,
    `При добавлении паспортных данных произошла ошибка`
  );

  return response;
};

export default addClientPassportInfo;
